/**
 * @typedef {import('../../js-doc').V1ClientReserveRateReason} V1ClientReserveRateReason
 * @typedef {import('../../js-doc').V1ClientLimitHistoryResponse} V1ClientLimitHistoryResponse
 * @typedef {import('../../js-doc').V1ReserveRateHistoryResponse} V1ReserveRateHistoryResponse
 * @typedef {import('../../js-doc').V1ReserveTotalResponse} V1ReserveTotalResponse
 * @typedef {import('../../js-doc').V2ClientReserveRateStatus} V2ClientReserveRateStatus
 * @typedef {import('../../js-doc').V2ClientReserveRateHistory} V2ClientReserveRateHistory
 * @typedef {import('../../js-doc').V2ClientLimitHistory} V2ClientLimitHistory
 * @typedef {import('../../js-doc').V2ReserveTotalResponse} V2ReserveTotalResponse
 */

import { CError } from '../../../consoleMixin'
import { UserMapper } from '../user'

/**
 * @param {V2ClientReserveRateHistory} v2ReserveRateHistory - V2 reserve rate history
 * @returns {V1ReserveRateHistoryResponse}
 */
export const mapV2ClientReserveRateHistory = (v2ReserveRateHistory) => {
  return {
    changelog_notes: v2ReserveRateHistory.note,
    updated_at: v2ReserveRateHistory.createdAt,
    reserve_rate_percentage: v2ReserveRateHistory.reserveRatePercentage,
    reserve_rate_change_reason: mapV2ClientReserveRateStatusV1(v2ReserveRateHistory.reserveRateReason),
    updated_by_user: UserMapper.v2AuditResponseToV1(v2ReserveRateHistory),
  }
}

/**
 * @param {V2ClientLimitHistory} v2ClientLimitHistory - V2 client limit history
 * @returns {V1ClientLimitHistoryResponse}
 */
export const mapV2ClientLimitHistory = (v2ClientLimitHistory) => {
  return {
    changelog_notes: v2ClientLimitHistory.note,
    updated_at: v2ClientLimitHistory.createdAt,
    client_limit: v2ClientLimitHistory.clientLimit,
    updated_by_user: UserMapper.v2AuditResponseToV1(v2ClientLimitHistory),
  }
}

/**
 * @param {V2ClientReserveRateStatus} v2Reason - V2 reserve rate change reason
 * @returns {V1ClientReserveRateReason}
 */
const mapV2ClientReserveRateStatusV1 = (v2Reason) => {
  switch (v2Reason) {
    case 'dilution_rate':
      return 'dilution rate'
    case 'volume':
      return 'volume'
    case 'high_risk_brokers':
      return 'high risk brokers'
    case 'general_risk':
      return 'general risk'
    case 'other':
      return 'other'
    case 'none':
      return 'none'
    default:
      CError(`Client reserve rate ${v2Reason} can't be mapped from v1 to v2`)
      return 'other'
  }
}

/**
 * @param {V2ReserveTotalResponse} v2ReserveTotalResponse - V2 reserve total response
 * @returns {V1ReserveTotalResponse}
 */
export const mapV2ClientReserveTotal = (v2ReserveTotalResponse) => {
  return {
    total: v2ReserveTotalResponse.amount,
  }
}
